import { useFormik } from "formik"
import { TApiSavedReport, TApiSavedReportFormObject } from "../saved-reports-types"
import { useSaveReportMutation } from "../queries/use-save-report-mutation"
import { useEffect } from "react"
import { useUpdateSavedReportMutation } from "../queries/use-update-saved-report-mutation"

interface Props {
  initialValues: TApiSavedReportFormObject
  onSuccess(savedReport: TApiSavedReport): void
}

export function useSavedReportFormik(props: Props) {
  const {
    initialValues,
    onSuccess,
  } = props

  const saveReportMutation = useSaveReportMutation()
  const updateSavedReportMutation = useUpdateSavedReportMutation()

  useEffect(() => {
    if (saveReportMutation.isError) {
      formik.setErrors(saveReportMutation.error)
    }

  }, [saveReportMutation.isError])

  const formik = useFormik<TApiSavedReportFormObject>({
    enableReinitialize: true,
    initialValues: {
      name: '',
      visibility: 'private',
      ...initialValues
    },
    onSubmit: async (values) => {
      const mutation = values.id ? updateSavedReportMutation : saveReportMutation

      return mutation.mutate(values, {
        onSuccess: (data) => {
          onSuccess?.(data)
        }
      })
    }
  }) 

  return formik
}